module.exports = __webpack_public_path__ + "assets/dropdownIcon.3e82c3f3.svg";